import React from 'react';
import CashierProductHandleButton, { CashierProductHandleType } from '../../components/CashierProductHandleButton';

const CashierReOrdering = () => {
  return (
    <>
      <CashierProductHandleButton type={CashierProductHandleType.REORDERING} />
    </>
  );
};

export default CashierReOrdering;
